import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from 'src/app/service/user.service';
import { alertModal, extractErrorMessage } from '../helpers/alert';

/**
 * The person sets their own password. Forced after an Admin's reset
 * (localStorage.mustChangePassword = 'true', enforced by the route guard), and
 * reachable any time from /change-password (per founder, 20 Oct 2026).
 */
@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css'],
})
export class ChangePasswordComponent {
  private readonly users = inject(UserService);
  private readonly router = inject(Router);
  current = '';
  next = '';
  confirm = '';
  busy = false;
  error = '';
  readonly forced = localStorage.getItem('mustChangePassword') === 'true';
  readonly userName = localStorage.getItem('username') || '';

  submit(): void {
    this.error = '';
    if (this.next.length < 8) { this.error = 'The new password needs at least 8 characters.'; return; }
    if (this.next !== this.confirm) { this.error = 'The two new passwords do not match.'; return; }
    if (this.next === this.current) { this.error = 'Choose a different password.'; return; }
    this.busy = true;
    this.users.setOwnPassword(this.current, this.next).subscribe({
      next: () => {
        localStorage.setItem('mustChangePassword', 'false');
        alertModal('success', 'Your password is set.');
        void this.router.navigate(['/home']);
      },
      error: (err) => { this.busy = false; this.error = extractErrorMessage(err, 'Could not change the password'); },
    });
  }
}
